import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getBaseUrl } from "../utils/apiHelper";

const ResetPasswordLink = () => {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("Validating reset link...");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    const codeParam = params.get("code");
    setEmail(emailParam || "");
    setCode(codeParam || "");
    if (!emailParam || !codeParam) {
      setStatus("fail");
      setMessage("Missing email or code in the link.");
      return;
    }
    // Optionally, validate code with backend here
    setShowForm(true);
  }, [location.search]);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const res = await fetch(`${getBaseUrl()}/api/auth/reset-password-with-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code, newPassword })
      });
      const data = await res.json();
      if (res.ok) {
        setStatus("success");
        setMessage("✅ Password reset! You can now log in.");
        setShowForm(false);
      } else {
        setStatus("fail");
        setMessage(data.message || "Password reset failed.");
      }
    } catch (err) {
      setStatus("fail");
      setMessage("Password reset failed.");
    }
  };

  return (
    <div className="form-container" style={{textAlign:'center',marginTop:40}}>
      <h2>Reset your Ledger-Link password</h2>
      {showForm ? (
        <form onSubmit={handleReset} style={{maxWidth:400,margin:"0 auto"}}>
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required placeholder="New Password" style={{width:'100%',marginBottom:12}} />
          <button type="submit" style={{padding:'10px 20px',borderRadius:6,background:'#0080ff',color:'#fff',border:'none',cursor:'pointer',fontWeight:'bold'}}>Set New Password</button>
        </form>
      ) : (
        <p style={{color: status === 'success' ? '#008000' : '#b30000', fontWeight:'bold', fontSize:18}}>{message}</p>
      )}
    </div>
  );
};

export default ResetPasswordLink;
